"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoicePayments = class UcInvoicePayments extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    reload;
    onReload(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("reload");
    }
    triggerButtonID;
    async $$load_triggerButtonID() {
        return this.$fn.randomElementId();
    }
    ux;
    b_6466705138206980_style;
    dataMembers = ['triggerButtonID', 'ux', 'b_6466705138206980_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                triggerButtonID: null,
                ux: null,
                b_6466705138206980_style: {
                    "min-width": "150px",
                },
            },
        };
    }
    get items() {
        if (this.loaded) {
            return this.invoice.payments.data;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_4592790460410433_showModal_7506_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                oid: $event.scope.item.transaction.id,
            },
        };
    }
    async evh_4592790460410433_click(event, scope) {
        return await this.actions.evh_4592790460410433_click.executeFromDOM(this, event, scope);
    }
    async act_322074727583344_resource_7508_getActionArgs($event) {
        return {
            method: "patch",
            target: this.invoice,
            data: {
                no_payment_required: $event.data.checked ? 'true' : null,
            },
        };
    }
    async evh_322074727583344_change(event, scope) {
        return await this.actions.evh_322074727583344_change.executeFromDOM(this, event, scope);
    }
    async act_5807883900791941_resource_7510_getActionArgs($event) {
        return {
            method: "patch",
            target: this.invoice,
            data: {
                uncollectible: $event.data.checked ? 'true' : null,
            },
        };
    }
    async evh_5807883900791941_change(event, scope) {
        return await this.actions.evh_5807883900791941_change.executeFromDOM(this, event, scope);
    }
    async act_1984986731969919_emit_7514_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1984986731969919_close_7513_getWhen($event) {
        return $event.data.ok;
    }
    async act_1984986731969919_showModal_7512_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                transactionKind: "cash_book",
                transactionType: this.invoice.invoice_kind == 'incoming' ? 'payment' : 'deposit',
                invoices: [this.invoice.id],
            },
        };
    }
    async evh_1984986731969919_clickPrevent(event, scope) {
        return await this.actions.evh_1984986731969919_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_298505142589676_emit_7518_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_298505142589676_close_7517_getWhen($event) {
        return $event.data.ok;
    }
    async act_298505142589676_showModal_7516_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                transactionKind: "bank",
                transactionType: this.invoice.invoice_kind == 'incoming' ? 'debit' : 'credit',
                invoices: [this.invoice.id],
            },
        };
    }
    async evh_298505142589676_clickPrevent(event, scope) {
        return await this.actions.evh_298505142589676_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_5738488038990219_emit_7522_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5738488038990219_close_7521_getWhen($event) {
        return $event.data.ok;
    }
    async act_5738488038990219_showModal_7520_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                transactionKind: "technical",
                transactionType: "invoice_reconciliation",
                invoices: [this.invoice.id],
            },
        };
    }
    async evh_5738488038990219_clickPrevent(event, scope) {
        return await this.actions.evh_5738488038990219_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_7481595298497917_emit_7526_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7481595298497917_close_7525_getWhen($event) {
        return $event.data.ok;
    }
    async act_7481595298497917_showModal_7524_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                transactionKind: "technical",
                transactionType: "write_off",
                invoices: [this.invoice.id],
            },
        };
    }
    async evh_7481595298497917_clickPrevent(event, scope) {
        return await this.actions.evh_7481595298497917_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7504 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7503 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7504,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7503],
        });
        const act_4592790460410433_showModal_7506 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4592790460410433_showModal_7506_getActionArgs,
            displayName: "OpenPayment",
            events: [],
        });
        const evh_4592790460410433_click_7505 = new core_1.actions.EventHandlerImpl({
            action: act_4592790460410433_showModal_7506,
            event: "click",
            displayName: "OpenPayment",
        });
        const evh_4592790460410433_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4592790460410433_click_7505],
        });
        const act_322074727583344_resource_7508 = new core_1.actions.ResourceAction({
            actionArgs: this.act_322074727583344_resource_7508_getActionArgs,
            events: [],
        });
        const evh_322074727583344_change_7507 = new core_1.actions.EventHandlerImpl({
            action: act_322074727583344_resource_7508,
            event: "change",
            displayName: "resource",
        });
        const evh_322074727583344_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_322074727583344_change_7507],
        });
        const act_5807883900791941_resource_7510 = new core_1.actions.ResourceAction({
            actionArgs: this.act_5807883900791941_resource_7510_getActionArgs,
            events: [],
        });
        const evh_5807883900791941_change_7509 = new core_1.actions.EventHandlerImpl({
            action: act_5807883900791941_resource_7510,
            event: "change",
            displayName: "resource",
        });
        const evh_5807883900791941_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5807883900791941_change_7509],
        });
        const act_1984986731969919_emit_7514 = new core_1.actions.EmitAction({
            actionArgs: this.act_1984986731969919_emit_7514_getActionArgs,
            events: [],
        });
        const evh_1984986731969919_close_7513 = new core_1.actions.EventHandlerImpl({
            action: act_1984986731969919_emit_7514,
            event: "close",
            when: this.evh_1984986731969919_close_7513_getWhen,
            displayName: "emit",
        });
        const act_1984986731969919_showModal_7512 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1984986731969919_showModal_7512_getActionArgs,
            displayName: "createCashPayment",
            events: [evh_1984986731969919_close_7513],
        });
        const evh_1984986731969919_clickPrevent_7511 = new core_1.actions.EventHandlerImpl({
            action: act_1984986731969919_showModal_7512,
            event: "click.prevent",
            displayName: "createCashPayment",
        });
        const evh_1984986731969919_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1984986731969919_clickPrevent_7511],
        });
        const act_298505142589676_emit_7518 = new core_1.actions.EmitAction({
            actionArgs: this.act_298505142589676_emit_7518_getActionArgs,
            events: [],
        });
        const evh_298505142589676_close_7517 = new core_1.actions.EventHandlerImpl({
            action: act_298505142589676_emit_7518,
            event: "close",
            when: this.evh_298505142589676_close_7517_getWhen,
            displayName: "emit",
        });
        const act_298505142589676_showModal_7516 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_298505142589676_showModal_7516_getActionArgs,
            displayName: "createBankingPayment",
            events: [evh_298505142589676_close_7517],
        });
        const evh_298505142589676_clickPrevent_7515 = new core_1.actions.EventHandlerImpl({
            action: act_298505142589676_showModal_7516,
            event: "click.prevent",
            displayName: "createBankingPayment",
        });
        const evh_298505142589676_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_298505142589676_clickPrevent_7515],
        });
        const act_5738488038990219_emit_7522 = new core_1.actions.EmitAction({
            actionArgs: this.act_5738488038990219_emit_7522_getActionArgs,
            events: [],
        });
        const evh_5738488038990219_close_7521 = new core_1.actions.EventHandlerImpl({
            action: act_5738488038990219_emit_7522,
            event: "close",
            when: this.evh_5738488038990219_close_7521_getWhen,
            displayName: "emit",
        });
        const act_5738488038990219_showModal_7520 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5738488038990219_showModal_7520_getActionArgs,
            displayName: "createReconciliation",
            events: [evh_5738488038990219_close_7521],
        });
        const evh_5738488038990219_clickPrevent_7519 = new core_1.actions.EventHandlerImpl({
            action: act_5738488038990219_showModal_7520,
            event: "click.prevent",
            displayName: "createReconciliation",
        });
        const evh_5738488038990219_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5738488038990219_clickPrevent_7519],
        });
        const act_7481595298497917_emit_7526 = new core_1.actions.EmitAction({
            actionArgs: this.act_7481595298497917_emit_7526_getActionArgs,
            events: [],
        });
        const evh_7481595298497917_close_7525 = new core_1.actions.EventHandlerImpl({
            action: act_7481595298497917_emit_7526,
            event: "close",
            when: this.evh_7481595298497917_close_7525_getWhen,
            displayName: "emit",
        });
        const act_7481595298497917_showModal_7524 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7481595298497917_showModal_7524_getActionArgs,
            displayName: "createBadDebt",
            events: [evh_7481595298497917_close_7525],
        });
        const evh_7481595298497917_clickPrevent_7523 = new core_1.actions.EventHandlerImpl({
            action: act_7481595298497917_showModal_7524,
            event: "click.prevent",
            displayName: "createBadDebt",
        });
        const evh_7481595298497917_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7481595298497917_clickPrevent_7523],
        });
        return {
            act_7315092382398562_reloadComponentData_7504,
            evh_7315092382398562_reload_7503,
            evh_7315092382398562_reload,
            act_4592790460410433_showModal_7506,
            evh_4592790460410433_click_7505,
            evh_4592790460410433_click,
            act_322074727583344_resource_7508,
            evh_322074727583344_change_7507,
            evh_322074727583344_change,
            act_5807883900791941_resource_7510,
            evh_5807883900791941_change_7509,
            evh_5807883900791941_change,
            act_1984986731969919_emit_7514,
            evh_1984986731969919_close_7513,
            act_1984986731969919_showModal_7512,
            evh_1984986731969919_clickPrevent_7511,
            evh_1984986731969919_clickPrevent,
            act_298505142589676_emit_7518,
            evh_298505142589676_close_7517,
            act_298505142589676_showModal_7516,
            evh_298505142589676_clickPrevent_7515,
            evh_298505142589676_clickPrevent,
            act_5738488038990219_emit_7522,
            evh_5738488038990219_close_7521,
            act_5738488038990219_showModal_7520,
            evh_5738488038990219_clickPrevent_7519,
            evh_5738488038990219_clickPrevent,
            act_7481595298497917_emit_7526,
            evh_7481595298497917_close_7525,
            act_7481595298497917_showModal_7524,
            evh_7481595298497917_clickPrevent_7523,
            evh_7481595298497917_clickPrevent,
            OpenPayment: act_4592790460410433_showModal_7506,
            createCashPayment: act_1984986731969919_showModal_7512,
            createBankingPayment: act_298505142589676_showModal_7516,
            createReconciliation: act_5738488038990219_showModal_7520,
            createBadDebt: act_7481595298497917_showModal_7524,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoicePayments.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoicePayments.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        default: null,
    }),
    __metadata("design:type", Object)
], UcInvoicePayments.prototype, "reload", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('reload'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoicePayments.prototype, "onReload", null);
UcInvoicePayments = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoicePayments);
exports.default = UcInvoicePayments;
vue_property_decorator_1.Vue.component("UcInvoicePayments", UcInvoicePayments);
